import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { FaEye, FaEyeSlash, FaHelmetSafety, FaUserPlus } from 'react-icons/fa6';

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: '', phone: '', password: '', project_name: '', address: '' });
  const [show, setShow] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [strength, setStrength] = useState(0);

  const set = (k) => (e) => {
    const v = e.target.value;
    setForm((f) => ({ ...f, [k]: v }));
    if (k === 'password') {
      let s = 0;
      if (v.length >= 6) s++;
      if (v.length >= 9) s++;
      if (/[A-Z]/.test(v) && /[0-9]/.test(v)) s++;
      setStrength(s);
    }
  };

  async function submit(e) {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await register(form);
      nav('/');
    } catch (e) {
      setErr(e.response?.data?.message || 'রেজিস্টার ব্যর্থ হয়েছে');
    } finally { setBusy(false); }
  }

  const strengthColor = ['bg-rose-500', 'bg-amber-500', 'bg-accent-500'][strength];

  return (
    <div className="min-h-dvh bg-slate-50 flex items-center justify-center p-4 py-8 bg-gradient-to-br from-ink-900 via-ink-800 to-ink-900">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-ink-100 shadow-card p-7">
        <div className="text-center mb-5">
          <div className="w-12 h-12 mx-auto rounded-xl bg-gradient-to-br from-brand-400 to-brand-600 text-white flex items-center justify-center text-xl mb-3"><FaHelmetSafety /></div>
          <h1 className="text-lg font-bold text-ink-900">নতুন প্রজেক্ট শুরু করুন</h1>
          <p className="text-xs text-ink-500 mt-1">Owner অ্যাকাউন্ট + প্রথম প্রজেক্ট তৈরি করুন</p>
        </div>
        {err && <div className="mb-4 text-sm bg-rose-50 text-rose-600 px-3 py-2.5 rounded-xl">⚠️ {err}</div>}
        <form onSubmit={submit} className="space-y-3.5">
          <div>
            <label className="label">আপনার নাম <span className="text-rose-500">*</span></label>
            <input className="input" placeholder="যেমন: আব্দুল করিম" value={form.name} onChange={set('name')} required />
          </div>
          <div>
            <label className="label">ফোন নম্বর <span className="text-rose-500">*</span></label>
            <input className="input" placeholder="01XXXXXXXXX" value={form.phone} onChange={set('phone')} inputMode="tel" required />
          </div>
          <div>
            <label className="label">পাসওয়ার্ড <span className="text-rose-500">*</span></label>
            <div className="relative">
              <input className="input pr-11" type={show ? 'text' : 'password'} value={form.password} onChange={set('password')} required />
              <button type="button" onClick={() => setShow(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-400 hover:text-ink-600"><span className="text-lg">{show ? <FaEyeSlash /> : <FaEye />}</span></button>
            </div>
            <div className="mt-2 h-1.5 w-full bg-ink-100 rounded-full overflow-hidden">
              <div className={`h-full ${strengthColor} transition-all`} style={{ width: `${Math.min(100, strength * 33)}%` }} />
            </div>
          </div>
          <div>
            <label className="label">প্রজেক্টের নাম <span className="text-rose-500">*</span></label>
            <input className="input" placeholder="যেমন: ১০তলা ভবন — ধানমন্ডি" value={form.project_name} onChange={set('project_name')} required />
          </div>
          <div>
            <label className="label">ঠিকানা</label>
            <input className="input" placeholder="রোড, এলাকা, ঢাকা" value={form.address} onChange={set('address')} />
          </div>
          <button disabled={busy} className="btn-primary w-full py-3 mt-2 font-semibold">
            {busy ? 'তৈরি হচ্ছে…' : <span className="flex items-center justify-center gap-2"><FaUserPlus /> রেজিস্টার করুন</span>}
          </button>
        </form>
        <p className="text-center text-sm text-ink-500 mt-5">
          ইতিমধ্যে অ্যাকাউন্ট আছে? <Link to="/login" className="font-semibold text-brand-600 hover:text-brand-700">লগইন</Link>
        </p>
      </div>
    </div>
  );
}